import styled from '@emotion/styled';
import useSidePanelContext from '@features/ui-layout/services/useSidePanelContext';
import { ReactNode } from 'react';

export const BodyWrapper = styled.div`
  min-height: 100vh;
  min-width: fit-content;
`;

interface ContentWrapperProps {
  children: ReactNode;
}

export const ContentWrapper = ({ children }: ContentWrapperProps): JSX.Element => {
  const sidePanelContext = useSidePanelContext();

  return <ContentWrapperStyled sidePanelWidth={sidePanelContext?.sidePanelWidth}>{children}</ContentWrapperStyled>;
};

const ContentWrapperStyled = styled.main<{ sidePanelWidth?: string }>`
  width: calc(100vw - var(--width-sidebar));
  min-width: var(--width-content-min);
  max-width: var(--width-content-max);

  margin-right: ${props => (props.sidePanelWidth ? `calc(${props.sidePanelWidth} + 1rem)` : '0')};
  margin-left: var(--width-sidebar);
  padding-top: var(--height-header);

  z-index: var(--z-index-content);

  background: lightblue;
  border: 1px solid blue;
`;
